import { BdsGrid, BdsLoadingSpinner } from 'blip-ds/dist/blip-ds-react/components';
import { NoHistory } from 'components/NoHistory';
import { Sidebar } from 'components/Sidebar/Sidebar';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { TicketMessage } from 'typings/components/TicketMessage';
import { MessageFilter } from '../MessageFilter/MessageFilter';
import './styles.scss';

export type TicketSideBarProps = {
    sidebarOpen: boolean;
    setSidebarOpen: (value: boolean) => void;
    customerName: string;
    contactMessages: TicketMessage[] | undefined;
    sideBarLoading: boolean;
};

export const TicketSideBar = ({
    sidebarOpen,
    setSidebarOpen,
    customerName,
    contactMessages,
    sideBarLoading,
}: TicketSideBarProps) => {
    const { t } = useTranslation();
    const blipSidebarRef = useRef<any>(null);
    useEffect(() => {
        if (typeof document === 'undefined') return;
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = sidebarOpen ? 'hidden' : previousOverflow;

        return () => {
            document.body.style.overflow = previousOverflow;
        };
    }, [sidebarOpen]);

    useEffect(() => {
        if (!sideBarLoading && contactMessages && contactMessages.length > 0) {
            setTimeout(() => {
                blipSidebarRef.current.scrollIntoView({
                    behavior: 'instant',
                    block: 'end',
                });
            }, 200);
        }
    }, [sideBarLoading, contactMessages]);

    return (
        <div>
            <Sidebar
                sidebarPosition="right"
                width={500}
                isOpen={sidebarOpen}
                handleClose={(content: CustomEvent) => {
                    if (content.detail.value === false) {
                        setSidebarOpen(false);
                    }
                }}
            >
                {sideBarLoading ? (
                    <div style={{ height: '100%' }} slot="body">
                        <BdsGrid
                            data-testid="loading-spinner"
                            height="100%"
                            container={true}
                            justifyContent="center"
                            alignItems="center"
                        >
                            <BdsLoadingSpinner />
                        </BdsGrid>
                    </div>
                ) : (
                    <>
                        <div slot="header">
                            <div className="ticket-sidebar-header">
                                {t('go-personal-sidebar-conversation-with')} {customerName}
                            </div>
                        </div>
                        {contactMessages?.length === 0 ? (
                            <div ref={blipSidebarRef} slot="body">
                                <NoHistory />
                            </div>
                        ) : (
                            <div ref={blipSidebarRef} slot="body">
                                <BdsGrid direction="column-reverse" gap="2">
                                    {contactMessages?.map(message => (
                                        <MessageFilter key={message.id} message={message} />
                                    ))}
                                </BdsGrid>
                            </div>
                        )}
                    </>
                )}
            </Sidebar>
        </div>
    );
};
